import { makeStyles } from "@hawkins/styles";
import { Dimensions } from "@hawkins/variables";

export const useUserInfoStyles = makeStyles({
  formGridColumn: {
    width: '100%',
    padding: Dimensions.Space16,
    rowGap: Dimensions.Space24,
    display: 'grid',
  },
});
